const WEBSOCKET_URL = process.env.REACT_APP_WEBSOCKET_URL || 'wss://ws.remote.it/beta'

export function getWebSocketURL(): string {
  return WEBSOCKET_URL
}
